// page.js — gemeinsamer Ablauf für Seiten in allen Bereichen: Router-Ergebnis → Seitenmodul rendern.
// Ein Seitenmodul exportiert `render(ctx)`; optional gibt es eine Aufräumfunktion zurück.
import { newPageScope } from './api.js';
import { t } from './i18n.js';
import { html, render } from '../ui/core/h.js';

let cleanup = null;
let currentMod = null;
let generation = 0; // jede neue Seite zählt hoch; eine überholte asynchrone render() darf nichts mehr anfassen
export async function mountPage(state, ctx) {
  const mod0 = state.route && state.route.module;
  // Gleiches Seitenmodul mit update(): nur aktualisieren (z. B. Liste → Spot-Detail, Karte bleibt)
  if (mod0 && mod0 === currentMod && typeof mod0.update === 'function' && !state.error) {
    ctx.shell.setActive(state.route.nav || '');
    if (state.route.title) document.title = state.route.title + ' · ViaCamp';
    return mod0.update({ ...ctx, outlet: ctx.shell.outlet, params: state.params, query: state.query, state });
  }
  if (typeof cleanup === 'function') { try { cleanup(); } catch (e) { console.error(e); } }
  cleanup = null;
  currentMod = mod0 || null;
  const my = ++generation;
  const signal = newPageScope();
  const outlet = ctx.shell.outlet;
  if (state.error || !state.route || !state.route.module) {
    render(outlet, html`<div class="vc-empty"><span class="vc-icon" aria-hidden="true">${state.notFound ? 'explore_off' : 'error'}</span>
      <h3>${t(state.notFound ? 'ui.not_found_title' : 'ui.load_error_title')}</h3>
      <p>${t(state.notFound ? 'ui.not_found_text' : 'ui.load_error_text')}</p></div>`);
    return;
  }
  const mod = state.route.module;
  ctx.shell.setActive(state.route.nav || '');
  if (state.route.title) document.title = state.route.title + ' · ViaCamp';
  try {
    const r = await mod.render({ ...ctx, outlet, params: state.params, query: state.query, signal, state });
    if (my !== generation) { if (typeof r === 'function') { try { r(); } catch {} } return; } // überholt: sofort aufräumen
    if (typeof r === 'function') cleanup = r;
  } catch (e) {
    // Überholt (z. B. Weiterleitung ins Onboarding während des Ladens): Fehler der alten Seite nicht über die neue malen.
    if (my !== generation) return;
    console.error('[page]', state.route && state.route.path, e);
    render(outlet, html`<div class="vc-empty"><span class="vc-icon" aria-hidden="true">error</span>
      <h3>${t('ui.load_error_title')}</h3><p>${t('ui.load_error_text')}</p></div>`);
  }
  if (ctx.focusOnNavigate !== false && state.fromNav) outlet.focus({ preventScroll: true });
}
